import React, { Fragment, useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { SITENAMEALIAS } from "../utils/init";
import {
  FetchUsdBtcLedgerAmount,
  SaveAutoWithdrawal,
  GetAutoWithdrawal,
  DeleteAutoWithdrawal,
  getCryptoAddress,
  GetUserDetails,
} from "../utils/service";
import { showToast } from "../utils/library";
import { Link, useHistory } from "react-router-dom";

const S = {
  pageWrapper: { padding: "36px 24px 60px" },
  headerRow: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "24px",
    gap: "12px",
  },
  iconBox: {
    width: "44px",
    height: "44px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    color: "var(--btn-color)",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
    flexShrink: 0,
    marginTop: "2px",
  },
  pageTitle: {
    fontSize: "22px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: "0 0 4px",
  },
  pageSubtitle: { fontSize: "13px", opacity: 0.55, margin: 0 },
  // ── Tabs ──
  tabsBar: {
    display: "flex",
    gap: "4px",
    marginBottom: "24px",
    background: "var(--body-color-less)",
    borderRadius: "14px",
    border: "1px solid var(--body-color-less2)",
    padding: "5px",
    width: "fit-content",
  },
  tabBtn: (active) => ({
    padding: "9px 22px",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    transition: "all 0.18s ease",
    background: active ? "var(--btn-color)" : "transparent",
    color: active ? "#fff" : "var(--text-color)",
    opacity: active ? 1 : 0.55,
  }),
  // ── Info Banner ──
  infoBox: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 10%, transparent), color-mix(in srgb, var(--btn-color) 4%, transparent))",
    border: "1px solid color-mix(in srgb, var(--btn-color) 22%, transparent)",
    borderRadius: "12px",
    padding: "14px 18px",
    fontSize: "13px",
    color: "var(--text-color)",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "28px",
    lineHeight: "1.55",
  },
  infoIcon: { color: "var(--btn-color)", fontSize: "18px", flexShrink: 0 },
  // ── Form cards ──
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    padding: "28px 32px",
    marginBottom: "24px",
  },
  stepLabel: {
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: "var(--btn-color)",
    marginBottom: "6px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: "0 0 4px",
  },
  sectionSubtitle: {
    fontSize: "12px",
    opacity: 0.5,
    margin: "0 0 20px",
  },
  cryptoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "12px",
  },
  cryptoCard: (selected) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    padding: "16px 10px",
    borderRadius: "14px",
    border: selected
      ? "2px solid var(--btn-color)"
      : "2px solid var(--body-color-less2)",
    background: selected
      ? "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))"
      : "var(--body-color-less)",
    cursor: "pointer",
    transition: "all 0.18s ease",
    position: "relative",
    userSelect: "none",
  }),
  cryptoLogo: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "contain",
  },
  cryptoName: (selected) => ({
    fontSize: "12px",
    fontWeight: "600",
    color: selected ? "var(--btn-color)" : "var(--text-color)",
    textAlign: "center",
    lineHeight: "1.3",
  }),
  cryptoCode: {
    fontSize: "11px",
    opacity: 0.5,
    textAlign: "center",
  },
  checkBadge: {
    position: "absolute",
    top: "8px",
    right: "8px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "var(--btn-color)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checkIcon: { color: "#fff", fontSize: "10px" },
  radioGroup: { display: "flex", gap: "12px", flexWrap: "wrap" },
  radioCard: (selected) => ({
    flex: "1 1 160px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 18px",
    borderRadius: "14px",
    border: selected
      ? "2px solid var(--btn-color)"
      : "2px solid var(--body-color-less2)",
    background: selected
      ? "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))"
      : "var(--body-color-less)",
    cursor: "pointer",
    transition: "all 0.18s ease",
    userSelect: "none",
  }),
  radioDot: (selected) => ({
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    border: selected
      ? "5px solid var(--btn-color)"
      : "2px solid var(--body-color-less2)",
    background: selected ? "#fff" : "transparent",
    flexShrink: 0,
    transition: "all 0.18s ease",
    boxSizing: "border-box",
  }),
  radioIcon: (selected) => ({
    fontSize: "22px",
    color: selected ? "var(--btn-color)" : "var(--text-color)",
    opacity: selected ? 1 : 0.4,
    transition: "all 0.18s ease",
  }),
  radioLabel: (selected) => ({
    fontSize: "13px",
    fontWeight: "600",
    color: selected ? "var(--btn-color)" : "var(--text-color)",
    transition: "color 0.18s ease",
  }),
  inputWrapper: { position: "relative" },
  inputPrefix: {
    position: "absolute",
    left: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "14px",
    fontWeight: "600",
    color: "var(--text-color)",
    opacity: 0.5,
    pointerEvents: "none",
  },
  inputSuffix: {
    position: "absolute",
    right: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "12px",
    fontWeight: "600",
    color: "var(--text-color)",
    opacity: 0.45,
    pointerEvents: "none",
  },
  input: {
    width: "100%",
    padding: "13px 16px 13px 36px",
    background: "var(--body-color-less2)",
    border: "1.5px solid var(--body-color-less2)",
    borderRadius: "12px",
    fontSize: "14px",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.18s ease",
  },
  inputHint: {
    fontSize: "11px",
    opacity: 0.45,
    marginTop: "6px",
  },
  submitRow: { display: "flex", justifyContent: "flex-end", marginTop: "8px" },
  btnPrimary: {
    padding: "12px 32px",
    background: "var(--btn-color)",
    color: "#fff",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    transition: "opacity 0.18s ease",
  },
  loaderRow: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
    opacity: 0.5,
  },
  errorText: { color: "#ef4444", fontSize: "11px", marginTop: "5px" },
  // ── Table cards ──
  txCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    overflow: "hidden",
  },
  txCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
    gap: "12px",
    flexWrap: "wrap",
  },
  txHeaderLeft: { display: "flex", alignItems: "center", gap: "12px" },
  txIconBox: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "#8b5cf6",
    background:
      "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
    flexShrink: 0,
  },
  txTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  txSubtitle: { fontSize: "12px", opacity: 0.5, margin: "2px 0 0" },
  tableWrapper: { overflowX: "auto" },
  table: { width: "100%", borderCollapse: "separate", borderSpacing: 0 },
  th: {
    padding: "11px 18px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: "#8b5cf6",
    background:
      "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 8%, transparent), color-mix(in srgb, #8b5cf6 3%, transparent))",
    borderBottom: "2px solid color-mix(in srgb, #8b5cf6 18%, transparent)",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  td: {
    padding: "14px 18px",
    fontSize: "13px",
    color: "var(--text-color)",
    borderBottom:
      "1px solid color-mix(in srgb, var(--body-color-less2) 70%, transparent)",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  badge: (color) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "11px",
    fontWeight: "600",
    background:
      color === "green"
        ? "rgba(16,185,129,0.12)"
        : color === "amber"
        ? "rgba(245,158,11,0.12)"
        : color === "red"
        ? "rgba(239,68,68,0.12)"
        : "rgba(139,92,246,0.12)",
    color:
      color === "green"
        ? "#10b981"
        : color === "amber"
        ? "#f59e0b"
        : color === "red"
        ? "#ef4444"
        : "#8b5cf6",
  }),
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "52px 20px",
    gap: "12px",
  },
  emptyIcon: { fontSize: "40px", opacity: 0.2 },
  emptyText: { fontSize: "14px", fontWeight: "600", opacity: 0.4, margin: 0 },
  emptySubtext: {
    fontSize: "12px",
    opacity: 0.3,
    margin: 0,
    textAlign: "center",
  },
  // ── Action buttons ──
  actionBtn: (type) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "5px 12px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    transition: "opacity 0.18s ease",
    background:
      type === "edit"
        ? "color-mix(in srgb, var(--btn-color) 12%, transparent)"
        : "rgba(239,68,68,0.1)",
    color: type === "edit" ? "var(--btn-color)" : "#ef4444",
  }),
  currencyTag: {
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 8px",
    borderRadius: "999px",
    fontSize: "11px",
    fontWeight: "600",
    background: "rgba(139,92,246,0.1)",
    color: "#8b5cf6",
  },
  // ── Modal ──
  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "20px",
  },
  modalBox: {
    background: "var(--body-color-less)",
    borderRadius: "20px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    width: "100%",
    maxWidth: "700px",
    maxHeight: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: "1px solid var(--body-color-less2)",
    flexShrink: 0,
  },
  modalTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  modalCloseBtn: {
    background: "transparent",
    border: "none",
    fontSize: "20px",
    color: "var(--text-color)",
    cursor: "pointer",
    opacity: 0.5,
    display: "flex",
    alignItems: "center",
    padding: "4px",
    lineHeight: 1,
  },
  modalBody: {
    padding: "24px",
    overflowY: "auto",
    flex: 1,
  },
  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "16px 24px",
    borderTop: "1px solid var(--body-color-less2)",
    flexShrink: 0,
  },
  btnSecondary: {
    padding: "11px 24px",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    transition: "opacity 0.18s ease",
  },
  btnDanger: {
    padding: "11px 24px",
    background: "#ef4444",
    color: "#fff",
    borderRadius: "12px",
    fontSize: "14px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    transition: "opacity 0.18s ease",
  },
  deleteIconBox: {
    width: "56px",
    height: "56px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "26px",
    color: "#ef4444",
    background: "rgba(239,68,68,0.1)",
    margin: "0 auto 16px",
  },
};

const DESTINATIONS = [
  {
    value: "platform_wallet",
    label: "Platform Wallet",
    icon: "mdi mdi-wallet",
  },
  {
    value: "external_wallet",
    label: "External Wallet",
    icon: "mdi mdi-bitcoin",
  },
  { value: "bank_account", label: "Bank Account", icon: "mdi mdi-bank" },
];

const DEST_MAP = {
  platform_wallet: "PLATFORM_WALLET",
  external_wallet: "EXTERNAL_WALLET",
  bank_account: "BANK_ACCOUNT",
};

const DEST_MAP_REVERSE = {
  PLATFORM_WALLET: "platform_wallet",
  EXTERNAL_WALLET: "external_wallet",
  BANK_ACCOUNT: "bank_account",
};

const DEST_LABEL = {
  PLATFORM_WALLET: "Platform Wallet",
  EXTERNAL_WALLET: "External Wallet",
  BANK_ACCOUNT: "Bank Account",
};

const RULES_COLUMNS = [
  "#",
  "Withdrawal Type",
  "Amount (USD)",
  "Frequency",
  "Currencies",
  "Actions",
];

const AutomateWithdrawals = () => {
  const history = useHistory();

  const [cryptos, setCryptos] = useState([]);
  const [loading, setLoading] = useState(true);

  const [lastSelectedCrypto, setLastSelectedCrypto] = useState(null);
  const [selectedCryptos, setSelectedCryptos] = useState([]);
  const [destination, setDestination] = useState("platform_wallet");
  const [amount, setAmount] = useState("");
  const [frequency, setFrequency] = useState("");
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [destChecking, setDestChecking] = useState(false);
  const [bitcoinAddresses, setBitcoinAddresses] = useState([]);
  const [bankVerified, setBankVerified] = useState(false);
  const [cryptoAddrModal, setCryptoAddrModal] = useState(false);
  const [bankModal, setBankModal] = useState(false);
  const [bankModalStatus, setBankModalStatus] = useState(null);
  const [hasAddrError, setHasAddrError] = useState(false);
  const [hasBankError, setHasBankError] = useState(false);

  const [rules, setRules] = useState([]);
  const [rulesLoading, setRulesLoading] = useState(false);
  const [rulesKey, setRulesKey] = useState(0);

  const [editModal, setEditModal] = useState(null);
  const [editDest, setEditDest] = useState("platform_wallet");
  const [editAmount, setEditAmount] = useState("");
  const [editFrequency, setEditFrequency] = useState("");
  const [editCryptos, setEditCryptos] = useState([]);
  const [editErrors, setEditErrors] = useState({});
  const [editSubmitting, setEditSubmitting] = useState(false);
  const [editDestChecking, setEditDestChecking] = useState(false);
  const [editBitcoinAddresses, setEditBitcoinAddresses] = useState([]);
  const [editBankVerified, setEditBankVerified] = useState(false);
  const [editHasAddrError, setEditHasAddrError] = useState(false);
  const [editHasBankError, setEditHasBankError] = useState(false);

  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteSubmitting, setDeleteSubmitting] = useState(false);

  const pageTopRef = useRef(null);
  const scrollToErrorsRef = useRef(false);

  useEffect(() => {
    if (scrollToErrorsRef.current && Object.values(errors).some(Boolean)) {
      scrollToErrorsRef.current = false;
      pageTopRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [errors]);

  useEffect(() => {
    const payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    FetchUsdBtcLedgerAmount(payload)
      .then((res) => {
        const response = res.data[0];
        if (response && response.error === "0") {
          const coins = (response.coin_balance || []).filter(
            (c) => c.currency_type === "2"
          );
          setCryptos(coins);
        } else {
          showToast("error", response?.error_msg || "Failed to load assets");
        }
      })
      .catch(() => showToast("error", "Failed to load assets"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    if (!merchantId) return;
    setRulesLoading(true);
    GetAutoWithdrawal(merchantId)
      .then((data) => {
        if (data.status) {
          setRules(data.data?.autoWithdrawalDetails || []);
        }
      })
      .catch(() => showToast("error", "Failed to load auto-withdrawal rules"))
      .finally(() => setRulesLoading(false));
  }, [rulesKey]);

  const handleCloseCryptoAddrModal = () => {
    setSelectedCryptos((prev) => prev.filter((c) => c !== lastSelectedCrypto));
    setCryptoAddrModal(false);
  };

  const toggleCrypto = async (code) => {
    const isAdding = !selectedCryptos.includes(code);
    setSelectedCryptos((prev) =>
      isAdding ? [...prev, code] : prev.filter((c) => c !== code)
    );
    setErrors((e) => ({ ...e, cryptos: undefined }));

    if (destination === "external_wallet") {
      if (!isAdding) {
        setHasAddrError(false);
        setBitcoinAddresses((prev) => prev.filter((a) => a.code !== code));
        return;
      }
      const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
      const coin = cryptos.find((c) => c.currency_code === code);
      if (!coin) return;
      setDestChecking(true);
      try {
        const res = await getCryptoAddress({
          currency_id: coin.currency_id,
          merchant_id: merchantId,
        });
        const addresses = res.data;
        const addr = Array.isArray(addresses)
          ? addresses.find((addr) => addr.isEnabledAutoWithdraw === 1)
              ?.bitcoin_address || addresses[0]?.bitcoin_address
          : null;
        if (!addr) {
          setLastSelectedCrypto(code);
          setCryptoAddrModal(true);
          setHasAddrError(true);
        } else {
          setHasAddrError(false);
          setBitcoinAddresses((prev) => [
            ...prev.filter((a) => a.code !== coin.currency_code),
            {
              code: coin.currency_code,
              name: coin.currency_name,
              logo: coin.logo,
              address: addr,
            },
          ]);
        }
      } catch {
        showToast("error", "Failed to verify crypto address.");
      } finally {
        setDestChecking(false);
      }
    }
  };

  const handleDestinationChange = async (value) => {
    setDestination(value);
    setHasAddrError(false);
    setHasBankError(false);
    setBitcoinAddresses([]);
    setBankVerified(false);
    if (value === "external_wallet") {
      if (selectedCryptos.length === 0) return;
      const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
      const selectedCoins = cryptos.filter((c) =>
        selectedCryptos.includes(c.currency_code)
      );
      setDestChecking(true);
      try {
        let missing = false;
        const collected = [];
        for (const coin of selectedCoins) {
          const res = await getCryptoAddress({
            currency_id: coin.currency_id,
            merchant_id: merchantId,
          });
          const addresses = res.data;

          const addr = Array.isArray(addresses)
            ? addresses.find((addr) => addr.isEnabledAutoWithdraw === 1)
                ?.bitcoin_address || addresses[0]?.bitcoin_address
            : null;
          if (!addr) {
            missing = true;
          } else {
            collected.push({
              code: coin.currency_code,
              name: coin.currency_name,
              logo: coin.logo,
              address: addr,
            });
          }
        }
        if (missing) {
          setCryptoAddrModal(true);
          setHasAddrError(true);
          setBitcoinAddresses([]);
        } else setBitcoinAddresses(collected);
      } catch {
        showToast("error", "Failed to verify crypto address.");
      } finally {
        setDestChecking(false);
      }
    } else if (value === "bank_account") {
      setDestChecking(true);
      try {
        const res = await GetUserDetails();
        const status = res.data?.bankDetailsStatus;
        if (status === 2 || status === "2") {
          setBankVerified(true);
        } else {
          setBankModalStatus(status);
          setBankModal(true);
          setHasBankError(true);
        }
      } catch {
        showToast("error", "Failed to verify bank details.");
      } finally {
        setDestChecking(false);
      }
    }
  };

  const handleEditDestinationChange = async (value) => {
    setEditDest(value);
    setEditHasAddrError(false);
    setEditHasBankError(false);
    setEditBitcoinAddresses([]);
    setEditBankVerified(false);
    if (value === "external_wallet") {
      if (editCryptos.length === 0) return;
      const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
      const selectedCoins = cryptos.filter((c) =>
        editCryptos.includes(c.currency_code)
      );
      setEditDestChecking(true);
      try {
        let missing = false;
        const collected = [];
        for (const coin of selectedCoins) {
          const res = await getCryptoAddress({
            currency_id: coin.currency_id,
            merchant_id: merchantId,
          });
          const addresses = res.data;
          const addr = Array.isArray(addresses)
            ? addresses.find((addr) => addr.isEnabledAutoWithdraw === 1)
                ?.bitcoin_address || addresses[0]?.bitcoin_address
            : null;
          if (!addr) {
            missing = true;
          } else {
            collected.push({
              code: coin.currency_code,
              name: coin.currency_name,
              logo: coin.logo,
              address: addr,
            });
          }
        }
        if (missing) {
          setCryptoAddrModal(true);
          setEditHasAddrError(true);
          setEditBitcoinAddresses([]);
        } else setEditBitcoinAddresses(collected);
      } catch {
        showToast("error", "Failed to verify crypto address.");
      } finally {
        setEditDestChecking(false);
      }
    } else if (value === "bank_account") {
      setEditDestChecking(true);
      try {
        const res = await GetUserDetails();
        const status = res.data?.bankDetailsStatus;
        if (status === 2 || status === "2") {
          setEditBankVerified(true);
        } else {
          setBankModalStatus(status);
          setBankModal(true);
          setEditHasBankError(true);
        }
      } catch {
        showToast("error", "Failed to verify bank details.");
      } finally {
        setEditDestChecking(false);
      }
    }
  };

  const toggleEditCrypto = async (code) => {
    const isAdding = !editCryptos.includes(code);
    setEditCryptos((prev) =>
      isAdding ? [...prev, code] : prev.filter((c) => c !== code)
    );
    setEditErrors((e) => ({ ...e, cryptos: undefined }));

    if (editDest === "external_wallet") {
      if (!isAdding) {
        setEditHasAddrError(false);
        setEditBitcoinAddresses((prev) => prev.filter((a) => a.code !== code));
        return;
      }
      const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
      const coin = cryptos.find((c) => c.currency_code === code);
      if (!coin) return;
      setEditDestChecking(true);
      try {
        const res = await getCryptoAddress({
          currency_id: coin.currency_id,
          merchant_id: merchantId,
        });
        const addresses = res.data;
        const addr = Array.isArray(addresses)
          ? addresses.find((addr) => addr.isEnabledAutoWithdraw === 1)
              ?.bitcoin_address || addresses[0]?.bitcoin_address
          : null;
        if (!addr) {
          setCryptoAddrModal(true);
          setEditHasAddrError(true);
        } else {
          setEditHasAddrError(false);
          setEditBitcoinAddresses((prev) => [
            ...prev.filter((a) => a.code !== coin.currency_code),
            {
              code: coin.currency_code,
              name: coin.currency_name,
              logo: coin.logo,
              address: addr,
            },
          ]);
        }
      } catch {
        showToast("error", "Failed to verify crypto address.");
      } finally {
        setEditDestChecking(false);
      }
    }
  };

  const validateAmountField = (val) => {
    const amt = parseFloat(val);
    if (!val || isNaN(amt) || amt < 100)
      return "Minimum withdrawal amount is $100.";
    const parts = String(val).split(".");
    if (parts[0].length > 12) return "Amount must not exceed 12 digits.";
    if (parts[1] && parts[1].length > 6)
      return "Amount allows up to 6 decimal places.";
    return undefined;
  };

  const validateFrequencyField = (val) => {
    const freq = parseInt(val, 10);
    if (!val || isNaN(freq) || freq < 7) return "Minimum frequency is 7 days.";
    if (String(val).includes("."))
      return "Frequency does not allow decimal values.";
    if (freq > 999) return "Maximum frequency is 999 days.";
    return undefined;
  };

  const validate = () => {
    const errs = {};
    if (selectedCryptos.length === 0)
      errs.cryptos = "Please select at least one asset.";
    const amtErr = validateAmountField(amount);
    if (amtErr) errs.amount = amtErr;
    const freqErr = validateFrequencyField(frequency);
    if (freqErr) errs.frequency = freqErr;
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      if (errs.cryptos) scrollToErrorsRef.current = true;
      setErrors(errs);
      return;
    }
    setSubmitting(true);
    const merchantId = parseInt(
      localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      10
    );
    const currencyIds = cryptos
      .filter((c) => selectedCryptos.includes(c.currency_code))
      .map((c) => c.currency_id)
      .join(",");
    SaveAutoWithdrawal({
      id: 0,
      merchantId,
      withdrawalType: DEST_MAP[destination],
      amountInUSD: parseFloat(amount),
      frequencyDays: parseInt(frequency, 10),
      currencyIds,
    })
      .then((data) => {
        if (data.status) {
          showToast(
            "success",
            data.message || "Automatic withdrawal rule saved successfully."
          );
          setRulesKey((k) => k + 1);
        } else {
          showToast("error", data.message || "Failed to save rule.");
        }
      })
      .catch((err) => showToast("error", err.message || "Failed to save rule."))
      .finally(() => {
        setSubmitting(false);
        setSelectedCryptos([]);
        setDestination("platform_wallet");
        setAmount("");
        setFrequency("");
        setErrors({});
      });
  };

  const openEdit = async (rule) => {
    const dest = DEST_MAP_REVERSE[rule.withdrawType] || "platform_wallet";
    const codes = rule.currencies
      .map((c) => {
        const found = cryptos.find(
          (cr) => String(cr.currency_id) === String(c.currencyId)
        );
        return found ? found.currency_code : null;
      })
      .filter(Boolean);

    setEditModal(rule);
    setEditDest(dest);
    setEditAmount(String(rule.amountInUsd));
    setEditFrequency(String(rule.frequencyInDays));
    setEditCryptos(codes);
    setEditErrors({});
    setEditBitcoinAddresses([]);
    setEditBankVerified(false);
    setEditHasAddrError(false);
    setEditHasBankError(false);

    if (dest === "external_wallet" && codes.length > 0) {
      const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
      const selectedCoins = cryptos.filter((c) =>
        codes.includes(c.currency_code)
      );
      setEditDestChecking(true);
      try {
        let missing = false;
        const collected = [];
        for (const coin of selectedCoins) {
          const res = await getCryptoAddress({
            currency_id: coin.currency_id,
            merchant_id: merchantId,
          });
          const addresses = res.data;
          const addr = Array.isArray(addresses)
            ? addresses.find((addr) => addr.isEnabledAutoWithdraw === 1)
                ?.bitcoin_address || addresses[0]?.bitcoin_address
            : null;
          if (!addr) {
            missing = true;
          } else {
            collected.push({
              code: coin.currency_code,
              name: coin.currency_name,
              logo: coin.logo,
              address: addr,
            });
          }
        }
        if (missing) {
          setCryptoAddrModal(true);
          setEditHasAddrError(true);
          setEditBitcoinAddresses([]);
        } else setEditBitcoinAddresses(collected);
      } catch {
        showToast("error", "Failed to verify crypto address.");
      } finally {
        setEditDestChecking(false);
      }
    } else if (dest === "bank_account") {
      setEditDestChecking(true);
      try {
        const res = await GetUserDetails();
        const status = res.data?.bankDetailsStatus;
        if (status === 2 || status === "2") {
          setEditBankVerified(true);
        } else {
          setBankModalStatus(status);
          setBankModal(true);
          setEditHasBankError(true);
        }
      } catch {
        showToast("error", "Failed to verify bank details.");
      } finally {
        setEditDestChecking(false);
      }
    }
  };

  const closeEdit = () => {
    setEditModal(null);
    setEditErrors({});
    setEditBitcoinAddresses([]);
    setEditBankVerified(false);
    setEditHasAddrError(false);
    setEditHasBankError(false);
  };

  const handleDelete = () => {
    if (!deleteModal) return;
    setDeleteSubmitting(true);
    const merchantId = parseInt(
      localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      10
    );
    DeleteAutoWithdrawal(deleteModal.id, merchantId)
      .then((data) => {
        if (data.status) {
          showToast(
            "success",
            data.message || "Auto-withdrawal rule deleted successfully."
          );
          setRulesKey((k) => k + 1);
          setDeleteModal(null);
        } else {
          showToast("error", data.message || "Failed to delete rule.");
        }
      })
      .catch((err) =>
        showToast("error", err.message || "Failed to delete rule.")
      )
      .finally(() => setDeleteSubmitting(false));
  };

  const validateEdit = () => {
    const errs = {};
    if (editCryptos.length === 0)
      errs.cryptos = "Please select at least one asset.";
    const amtErr = validateAmountField(editAmount);
    if (amtErr) errs.amount = amtErr;
    const freqErr = validateFrequencyField(editFrequency);
    if (freqErr) errs.frequency = freqErr;
    return errs;
  };

  const handleEditSave = () => {
    const errs = validateEdit();
    if (Object.keys(errs).length > 0) {
      setEditErrors(errs);
      return;
    }
    setEditSubmitting(true);
    const merchantId = parseInt(
      localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      10
    );
    const currencyIds = cryptos
      .filter((c) => editCryptos.includes(c.currency_code))
      .map((c) => c.currency_id)
      .join(",");
    SaveAutoWithdrawal({
      id: editModal.id,
      merchantId,
      withdrawalType: DEST_MAP[editDest],
      amountInUSD: parseFloat(editAmount),
      frequencyDays: parseInt(editFrequency, 10),
      currencyIds,
    })
      .then((data) => {
        if (data.status) {
          showToast("success", data.message || "Rule updated successfully.");
          closeEdit();
          setRulesKey((k) => k + 1);
        } else {
          showToast("error", data.message || "Failed to update rule.");
        }
      })
      .catch((err) =>
        showToast("error", err.message || "Failed to update rule.")
      )
      .finally(() => setEditSubmitting(false));
  };

  return (
    <Fragment>
      <style>{`
        .aw-input::placeholder {
          color: var(--text-color);
          opacity: 0.35;
        }
      `}</style>
      <div className="container-scroller">
        <Sidebar />
        <Header />
        <div className="main-panel">
          <div ref={pageTopRef} style={S.pageWrapper}>
            {/* ── Page Header ── */}
            <div style={S.headerRow}>
              <div style={S.iconBox}>
                <i className="mdi mdi-autorenew" />
              </div>
              <div>
                <h4 style={S.pageTitle}>Automatic Withdrawal</h4>
                <p style={S.pageSubtitle}>
                  Configure automated withdrawal rules for your assets
                </p>
                <Link
                  to="/wallet"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "var(--btn-color)",
                    textDecoration: "none",
                    marginTop: "4px",
                  }}
                >
                  <i
                    className="mdi mdi-arrow-left"
                    style={{ fontSize: "14px" }}
                  />
                  Go back to settlement wallet
                </Link>
              </div>
            </div>

            {/* ── Info Banner ── */}
            <div style={S.infoBox}>
              <i className="mdi mdi-information-outline" style={S.infoIcon} />
              <span>
                Merchant needs to turn automatic withdrawals on. Otherwise
                withdrawals are as it is now, manual.
              </span>
            </div>

            {/* ── Form ── */}
            <form onSubmit={handleSubmit} noValidate>
              {/* Step 1: Choose Assets */}
              <div style={S.card}>
                <div style={S.stepLabel}>Step 1</div>
                <h5 style={S.sectionTitle}>Choose Assets</h5>
                <p style={S.sectionSubtitle}>
                  Select one or more cryptocurrencies for automatic withdrawal
                </p>

                {loading ? (
                  <div style={S.loaderRow}>
                    <i
                      className="mdi mdi-loading mdi-spin"
                      style={{ fontSize: "28px" }}
                    />
                  </div>
                ) : cryptos.length === 0 ? (
                  <p style={{ opacity: 0.5, fontSize: "13px" }}>
                    No assets available.
                  </p>
                ) : (
                  <div style={S.cryptoGrid}>
                    {cryptos.map((coin) => {
                      const selected = selectedCryptos.includes(
                        coin.currency_code
                      );
                      return (
                        <div
                          key={coin.currency_id}
                          style={S.cryptoCard(selected)}
                          onClick={() => toggleCrypto(coin.currency_code)}
                        >
                          {selected && (
                            <div style={S.checkBadge}>
                              <i
                                className="mdi mdi-check"
                                style={S.checkIcon}
                              />
                            </div>
                          )}
                          <img
                            src={coin.logo}
                            alt={coin.currency_code}
                            style={S.cryptoLogo}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <span style={S.cryptoName(selected)}>
                            {coin.currency_name.trim()}
                          </span>
                          <span style={S.cryptoCode}>{coin.currency_code}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
                {errors.cryptos && <p style={S.errorText}>{errors.cryptos}</p>}
              </div>

              {/* Step 2: Destination */}
              <div style={{ ...S.card, position: "relative" }}>
                <div style={S.stepLabel}>Step 2</div>
                <h5 style={S.sectionTitle}>Choose Destination</h5>
                <p style={S.sectionSubtitle}>
                  Select where the crypto will be sent
                </p>
                <div style={S.radioGroup}>
                  {DESTINATIONS.map((dest) => {
                    const sel = destination === dest.value;
                    return (
                      <div
                        key={dest.value}
                        style={{
                          ...S.radioCard(sel),
                          opacity: destChecking ? 0.6 : 1,
                          pointerEvents: destChecking ? "none" : "auto",
                        }}
                        onClick={() =>
                          !destChecking && handleDestinationChange(dest.value)
                        }
                      >
                        <div style={S.radioDot(sel)} />
                        <i className={dest.icon} style={S.radioIcon(sel)} />
                        <span style={S.radioLabel(sel)}>{dest.label}</span>
                      </div>
                    );
                  })}
                </div>
                {destChecking && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "12px",
                      fontSize: "12px",
                      opacity: 0.6,
                    }}
                  >
                    <i className="mdi mdi-loading mdi-spin" />
                    Verifying destination requirements...
                  </div>
                )}
                {destination === "bank_account" &&
                  bankVerified &&
                  !destChecking && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginTop: "14px",
                        padding: "12px 16px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, rgba(16,185,129,0.1), rgba(16,185,129,0.04))",
                        border: "1px solid rgba(16,185,129,0.25)",
                      }}
                    >
                      <i
                        className="mdi mdi-check-circle"
                        style={{
                          fontSize: "20px",
                          color: "#10b981",
                          flexShrink: 0,
                        }}
                      />
                      <div>
                        <p
                          style={{
                            fontSize: "11px",
                            fontWeight: "700",
                            textTransform: "uppercase",
                            letterSpacing: "0.8px",
                            color: "#10b981",
                            margin: "0 0 2px",
                          }}
                        >
                          Bank Verified
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            margin: 0,
                            opacity: 0.65,
                          }}
                        >
                          Your bank account has been verified and is ready for
                          withdrawals.
                        </p>
                      </div>
                    </div>
                  )}
                {destination === "external_wallet" &&
                  bitcoinAddresses.length > 0 &&
                  !destChecking && (
                    <div
                      style={{
                        marginTop: "14px",
                        borderRadius: "12px",
                        border:
                          "1px solid color-mix(in srgb, var(--btn-color) 22%, transparent)",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 16px",
                          background:
                            "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
                          borderBottom:
                            "1px solid color-mix(in srgb, var(--btn-color) 15%, transparent)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <i
                            className="mdi mdi-wallet-outline"
                            style={{
                              fontSize: "15px",
                              color: "var(--btn-color)",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              letterSpacing: "0.8px",
                              color: "var(--btn-color)",
                            }}
                          >
                            Crypto Addresses Found
                          </span>
                        </div>
                        <Link
                          to="/crypto-address"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "11px",
                            fontWeight: "600",
                            color: "var(--btn-color)",
                            textDecoration: "none",
                          }}
                        >
                          Update your address
                          <i
                            className="mdi mdi-arrow-right"
                            style={{ fontSize: "12px" }}
                          />
                        </Link>
                      </div>
                      {bitcoinAddresses.map((item, idx) => (
                        <div
                          key={item.code}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "11px 16px",
                            background:
                              "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 6%, transparent), color-mix(in srgb, var(--btn-color) 2%, transparent))",
                            borderTop:
                              idx > 0
                                ? "1px solid color-mix(in srgb, var(--btn-color) 10%, transparent)"
                                : "none",
                          }}
                        >
                          <img
                            src={item.logo}
                            alt={item.code}
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              objectFit: "contain",
                              flexShrink: 0,
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "var(--text-color)",
                                margin: "0 0 2px",
                              }}
                            >
                              {item.name.trim()}{" "}
                              <span style={{ opacity: 0.5, fontWeight: "400" }}>
                                ({item.code})
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: "11px",
                                color: "var(--text-color)",
                                margin: 0,
                                wordBreak: "break-all",
                                opacity: 0.6,
                                fontFamily: "monospace",
                              }}
                            >
                              {item.address}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              {/* Step 3 & 4 */}
              <div style={S.card}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(280px, 1fr))",
                    gap: "28px",
                  }}
                >
                  {/* Amount */}
                  <div>
                    <div style={S.stepLabel}>Step 3</div>
                    <h5 style={S.sectionTitle}>Withdrawal Amount</h5>
                    <p style={S.sectionSubtitle}>
                      Trigger withdrawal when balance reaches this amount
                    </p>
                    <div style={S.inputWrapper}>
                      <span style={S.inputPrefix}>$</span>
                      <input
                        type="number"
                        min="100"
                        max="999999999999"
                        step="any"
                        placeholder="100"
                        value={amount}
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "E")
                            e.preventDefault();
                        }}
                        onChange={(e) => {
                          setAmount(e.target.value);
                          setErrors((err) => ({
                            ...err,
                            amount: validateAmountField(e.target.value),
                          }));
                        }}
                        style={S.input}
                        className="aw-input"
                      />
                    </div>
                    <p style={S.inputHint}>
                      Min: $100 · Max: 12 digits · Up to 6 decimal places
                    </p>
                    {errors.amount && (
                      <p style={S.errorText}>{errors.amount}</p>
                    )}
                  </div>

                  {/* Frequency */}
                  <div>
                    <div style={S.stepLabel}>Step 4</div>
                    <h5 style={S.sectionTitle}>Withdrawal Frequency</h5>
                    <p style={S.sectionSubtitle}>
                      How often the automatic withdrawal should run
                    </p>
                    <div style={S.inputWrapper}>
                      <span style={{ ...S.inputPrefix, left: "14px" }}>
                        <i className="mdi mdi-calendar-clock" />
                      </span>
                      <input
                        type="number"
                        min="7"
                        max="999"
                        step="1"
                        placeholder="7"
                        value={frequency}
                        onKeyDown={(e) => {
                          if (e.key === "." || e.key === "e" || e.key === "E")
                            e.preventDefault();
                        }}
                        onChange={(e) => {
                          setFrequency(e.target.value);
                          setErrors((err) => ({
                            ...err,
                            frequency: validateFrequencyField(e.target.value),
                          }));
                        }}
                        style={S.input}
                        className="aw-input"
                      />
                      <span style={S.inputSuffix}>days</span>
                    </div>
                    <p style={S.inputHint}>
                      Min: 7 days · Max: 999 days · Whole numbers only
                    </p>
                    {errors.frequency && (
                      <p style={S.errorText}>{errors.frequency}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div style={S.submitRow}>
                <button
                  type="submit"
                  style={{
                    ...S.btnPrimary,
                    opacity:
                      submitting || hasAddrError || hasBankError ? 0.5 : 1,
                  }}
                  disabled={submitting || hasAddrError || hasBankError}
                >
                  {submitting ? (
                    <>
                      <i className="mdi mdi-loading mdi-spin" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <i className="mdi mdi-check-circle-outline" />
                      Save Automatic Withdrawal Rule
                    </>
                  )}
                </button>
              </div>
            </form>

            {/* ── Automate Withdrawals Configurations ── */}
            <div style={{ ...S.txCard, marginTop: "28px" }}>
              <div style={S.txCardHeader}>
                <div style={S.txHeaderLeft}>
                  <div style={S.txIconBox}>
                    <i className="mdi mdi-autorenew" />
                  </div>
                  <div>
                    <h5 style={S.txTitle}>
                      Automate Withdrawals Configurations
                    </h5>
                    <p style={S.txSubtitle}>
                      Your configured auto-withdrawal rules
                    </p>
                  </div>
                </div>
              </div>

              {rulesLoading ? (
                <div style={S.loaderRow}>
                  <i
                    className="mdi mdi-loading mdi-spin"
                    style={{ fontSize: "28px" }}
                  />
                </div>
              ) : rules.length === 0 ? (
                <div style={S.emptyState}>
                  <div style={S.emptyIcon}>
                    <i className="mdi mdi-autorenew" />
                  </div>
                  <p style={S.emptyText}>No rules configured</p>
                  <p style={S.emptySubtext}>
                    Save a rule above to see it listed here.
                  </p>
                </div>
              ) : (
                <div style={S.tableWrapper}>
                  <table style={S.table}>
                    <thead>
                      <tr>
                        {RULES_COLUMNS.map((col) => (
                          <th key={col} style={S.th}>
                            {col}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rules.map((rule, idx) => (
                        <tr key={rule.id}>
                          <td style={{ ...S.td, opacity: 0.6 }}>{idx + 1}</td>
                          <td style={S.td}>
                            <span style={S.currencyTag}>
                              {DEST_LABEL[rule.withdrawType] ||
                                rule.withdrawType}
                            </span>
                          </td>
                          <td style={{ ...S.td, fontWeight: "600" }}>
                            ${Number(rule.amountInUsd).toFixed(2)}
                          </td>
                          <td style={S.td}>
                            Every {rule.frequencyInDays} days
                          </td>
                          <td style={S.td}>
                            <div
                              style={{
                                display: "flex",
                                gap: "4px",
                                flexWrap: "wrap",
                              }}
                            >
                              {rule.currencies.map((c) => (
                                <span key={c.currencyId} style={S.currencyTag}>
                                  {c.currency}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td style={S.td}>
                            <div style={{ display: "flex", gap: "8px" }}>
                              <button
                                style={S.actionBtn("edit")}
                                onClick={() => openEdit(rule)}
                              >
                                <i className="mdi mdi-pencil" />
                                Edit
                              </button>
                              <button
                                style={S.actionBtn("delete")}
                                onClick={() => setDeleteModal(rule)}
                              >
                                <i className="mdi mdi-delete-outline" />
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* ── Delete Confirmation Modal ── */}
      {deleteModal && (
        <div
          style={S.modalOverlay}
          onClick={() => !deleteSubmitting && setDeleteModal(null)}
        >
          <div
            style={{ ...S.modalBox, maxWidth: "420px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={S.modalHeader}>
              <h5 style={S.modalTitle}>
                <i
                  className="mdi mdi-delete"
                  style={{ marginRight: "8px", color: "#ef4444" }}
                />
                Delete Rule
              </h5>
              <button
                style={S.modalCloseBtn}
                onClick={() => setDeleteModal(null)}
                disabled={deleteSubmitting}
              >
                <i className="mdi mdi-close" />
              </button>
            </div>

            <div
              style={{
                ...S.modalBody,
                textAlign: "center",
                padding: "32px 28px 24px",
              }}
            >
              <div style={S.deleteIconBox}>
                <i className="mdi mdi-delete-outline" />
              </div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "var(--text-color)",
                  margin: "0 0 8px",
                }}
              >
                Delete this auto-withdrawal rule?
              </p>
              <p
                style={{
                  fontSize: "13px",
                  opacity: 0.55,
                  margin: 0,
                  lineHeight: "1.6",
                }}
              >
                This will permanently remove the rule for{" "}
                <strong>
                  {(deleteModal.currencies || [])
                    .map((c) => c.currency)
                    .join(", ")}
                </strong>{" "}
                —{" "}
                <strong>
                  {DEST_LABEL[deleteModal.withdrawType] ||
                    deleteModal.withdrawType}
                </strong>
                , <strong>${Number(deleteModal.amountInUsd).toFixed(2)}</strong>{" "}
                every <strong>{deleteModal.frequencyInDays} days</strong>.
              </p>
            </div>

            <div style={S.modalFooter}>
              <button
                style={S.btnSecondary}
                onClick={() => setDeleteModal(null)}
                disabled={deleteSubmitting}
              >
                Cancel
              </button>
              <button
                style={{ ...S.btnDanger, opacity: deleteSubmitting ? 0.7 : 1 }}
                onClick={handleDelete}
                disabled={deleteSubmitting}
              >
                {deleteSubmitting ? (
                  <>
                    <i className="mdi mdi-loading mdi-spin" />
                    Deleting...
                  </>
                ) : (
                  <>
                    <i className="mdi mdi-delete-outline" />
                    Delete Rule
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Crypto Address Missing Modal ── */}
      {cryptoAddrModal && (
        <div
          style={{ ...S.modalOverlay, zIndex: 1100 }}
          onClick={handleCloseCryptoAddrModal}
        >
          <div
            style={{ ...S.modalBox, maxWidth: "420px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={S.modalHeader}>
              <h5 style={S.modalTitle}>
                <i
                  className="mdi mdi-wallet-outline"
                  style={{ marginRight: "8px", color: "#f59e0b" }}
                />
                Crypto Address Required
              </h5>
              <button
                style={S.modalCloseBtn}
                onClick={handleCloseCryptoAddrModal}
              >
                <i className="mdi mdi-close" />
              </button>
            </div>
            <div
              style={{
                ...S.modalBody,
                textAlign: "center",
                padding: "32px 28px 24px",
              }}
            >
              <div
                style={{
                  ...S.deleteIconBox,
                  color: "#f59e0b",
                  background: "rgba(245,158,11,0.1)",
                }}
              >
                <i className="mdi mdi-alert-circle-outline" />
              </div>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "var(--text-color)",
                  margin: "0 0 8px",
                }}
              >
                No Crypto Address Found
              </p>
              <p
                style={{
                  fontSize: "13px",
                  opacity: 0.55,
                  margin: 0,
                  lineHeight: "1.6",
                }}
              >
                You need to add a crypto address for the selected currency
                before setting up an external wallet withdrawal. Please add it
                in the <strong>Add Crypto Address</strong> section first.
              </p>
            </div>
            <div style={S.modalFooter}>
              <button
                style={S.btnSecondary}
                onClick={handleCloseCryptoAddrModal}
              >
                Cancel
              </button>
              <button
                style={{ ...S.btnPrimary }}
                onClick={() => {
                  setCryptoAddrModal(false);
                  history.push("/crypto-address");
                }}
              >
                <i className="mdi mdi-plus-circle-outline" />
                Add Crypto Address
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Bank Details Status Modal ── */}
      {bankModal &&
        (() => {
          let title, headline, message, btnIcon, btnLabel;
          if (bankModalStatus === null || bankModalStatus === undefined) {
            title = "Bank Account Required";
            headline = "Bank Details Not Submitted";
            message =
              "You haven't submitted your bank details yet. Please add your bank account before setting up a bank account withdrawal.";
            btnIcon = "mdi-bank-plus";
            btnLabel = "Add Bank Details";
          } else if (bankModalStatus === 0 || bankModalStatus === "0") {
            title = "Bank Account Pending";
            headline = "Bank Details Not Verified Yet";
            message =
              "Your bank details have been submitted and are currently under review. Please wait for verification before using bank account withdrawal.";
            btnIcon = "mdi-bank-outline";
            btnLabel = "View Bank Details";
          } else if (bankModalStatus === 3 || bankModalStatus === "3") {
            title = "Bank Account Rejected";
            headline = "Bank Details Rejected";
            message =
              "Your bank details submission was rejected. Please resubmit your bank details with the correct information to proceed.";
            btnIcon = "mdi-bank-refresh-outline";
            btnLabel = "Resubmit Bank Details";
          } else {
            title = "Bank Account Required";
            headline = "Bank Details Not Submitted";
            message =
              "You need to add and verify your bank account before setting up a bank account withdrawal.";
            btnIcon = "mdi-bank-plus";
            btnLabel = "Add Bank Details";
          }
          return (
            <div
              style={{ ...S.modalOverlay, zIndex: 1100 }}
              onClick={() => setBankModal(false)}
            >
              <div
                style={{ ...S.modalBox, maxWidth: "420px" }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={S.modalHeader}>
                  <h5 style={S.modalTitle}>
                    <i
                      className="mdi mdi-bank-outline"
                      style={{ marginRight: "8px", color: "#f59e0b" }}
                    />
                    {title}
                  </h5>
                  <button
                    style={S.modalCloseBtn}
                    onClick={() => setBankModal(false)}
                  >
                    <i className="mdi mdi-close" />
                  </button>
                </div>
                <div
                  style={{
                    ...S.modalBody,
                    textAlign: "center",
                    padding: "32px 28px 24px",
                  }}
                >
                  <div
                    style={{
                      ...S.deleteIconBox,
                      color: "#f59e0b",
                      background: "rgba(245,158,11,0.1)",
                    }}
                  >
                    <i className="mdi mdi-alert-circle-outline" />
                  </div>
                  <p
                    style={{
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "var(--text-color)",
                      margin: "0 0 8px",
                    }}
                  >
                    {headline}
                  </p>
                  <p
                    style={{
                      fontSize: "13px",
                      opacity: 0.55,
                      margin: 0,
                      lineHeight: "1.6",
                    }}
                  >
                    {message}
                  </p>
                </div>
                <div style={S.modalFooter}>
                  <button
                    style={S.btnSecondary}
                    onClick={() => setBankModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    style={{ ...S.btnPrimary }}
                    onClick={() => {
                      setBankModal(false);
                      history.push("/bank-info");
                    }}
                  >
                    <i className={`mdi ${btnIcon}`} />
                    {btnLabel}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      {/* ── Edit Modal ── */}
      {editModal && (
        <div style={S.modalOverlay} onClick={closeEdit}>
          <div style={S.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHeader}>
              <h5 style={S.modalTitle}>
                <i
                  className="mdi mdi-pencil"
                  style={{ marginRight: "8px", color: "var(--btn-color)" }}
                />
                Edit Auto-Withdrawal Rule
              </h5>
              <button style={S.modalCloseBtn} onClick={closeEdit}>
                <i className="mdi mdi-close" />
              </button>
            </div>

            <div style={S.modalBody}>
              {/* Assets */}
              <div style={{ marginBottom: "22px" }}>
                <div style={S.stepLabel}>Assets</div>
                {loading ? (
                  <div style={{ padding: "16px 0", opacity: 0.5 }}>
                    <i className="mdi mdi-loading mdi-spin" />
                  </div>
                ) : (
                  <div
                    style={{
                      ...S.cryptoGrid,
                      opacity: editDestChecking ? 0.6 : 1,
                      pointerEvents: editDestChecking ? "none" : "auto",
                    }}
                  >
                    {cryptos.map((coin) => {
                      const selected = editCryptos.includes(coin.currency_code);
                      return (
                        <div
                          key={coin.currency_id}
                          style={S.cryptoCard(selected)}
                          onClick={() => toggleEditCrypto(coin.currency_code)}
                        >
                          {selected && (
                            <div style={S.checkBadge}>
                              <i
                                className="mdi mdi-check"
                                style={S.checkIcon}
                              />
                            </div>
                          )}
                          <img
                            src={coin.logo}
                            alt={coin.currency_code}
                            style={S.cryptoLogo}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <span style={S.cryptoName(selected)}>
                            {coin.currency_name.trim()}
                          </span>
                          <span style={S.cryptoCode}>{coin.currency_code}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
                {editErrors.cryptos && (
                  <p style={S.errorText}>{editErrors.cryptos}</p>
                )}
              </div>

              {/* Withdrawal Type */}
              <div style={{ marginBottom: "22px" }}>
                <div style={S.stepLabel}>Withdrawal Type</div>
                <div style={S.radioGroup}>
                  {DESTINATIONS.map((dest) => {
                    const sel = editDest === dest.value;
                    return (
                      <div
                        key={dest.value}
                        style={{
                          ...S.radioCard(sel),
                          opacity: editDestChecking ? 0.6 : 1,
                          pointerEvents: editDestChecking ? "none" : "auto",
                        }}
                        onClick={() =>
                          !editDestChecking &&
                          handleEditDestinationChange(dest.value)
                        }
                      >
                        <div style={S.radioDot(sel)} />
                        <i className={dest.icon} style={S.radioIcon(sel)} />
                        <span style={S.radioLabel(sel)}>{dest.label}</span>
                      </div>
                    );
                  })}
                </div>
                {editDestChecking && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "12px",
                      fontSize: "12px",
                      opacity: 0.6,
                    }}
                  >
                    <i className="mdi mdi-loading mdi-spin" />
                    Verifying destination requirements...
                  </div>
                )}
                {editDest === "bank_account" &&
                  editBankVerified &&
                  !editDestChecking && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginTop: "14px",
                        padding: "12px 16px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, rgba(16,185,129,0.1), rgba(16,185,129,0.04))",
                        border: "1px solid rgba(16,185,129,0.25)",
                      }}
                    >
                      <i
                        className="mdi mdi-check-circle"
                        style={{
                          fontSize: "20px",
                          color: "#10b981",
                          flexShrink: 0,
                        }}
                      />
                      <div>
                        <p
                          style={{
                            fontSize: "11px",
                            fontWeight: "700",
                            textTransform: "uppercase",
                            letterSpacing: "0.8px",
                            color: "#10b981",
                            margin: "0 0 2px",
                          }}
                        >
                          Bank Verified
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "var(--text-color)",
                            margin: 0,
                            opacity: 0.65,
                          }}
                        >
                          Your bank account has been verified and is ready for
                          withdrawals.
                        </p>
                      </div>
                    </div>
                  )}
                {editDest === "external_wallet" &&
                  editBitcoinAddresses.length > 0 &&
                  !editDestChecking && (
                    <div
                      style={{
                        marginTop: "14px",
                        borderRadius: "12px",
                        border:
                          "1px solid color-mix(in srgb, var(--btn-color) 22%, transparent)",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 16px",
                          background:
                            "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
                          borderBottom:
                            "1px solid color-mix(in srgb, var(--btn-color) 15%, transparent)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <i
                            className="mdi mdi-wallet-outline"
                            style={{
                              fontSize: "15px",
                              color: "var(--btn-color)",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              letterSpacing: "0.8px",
                              color: "var(--btn-color)",
                            }}
                          >
                            Crypto Addresses Found
                          </span>
                        </div>
                        <Link
                          to="/crypto-address"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "11px",
                            fontWeight: "600",
                            color: "var(--btn-color)",
                            textDecoration: "none",
                          }}
                        >
                          Update your address
                          <i
                            className="mdi mdi-arrow-right"
                            style={{ fontSize: "12px" }}
                          />
                        </Link>
                      </div>
                      {editBitcoinAddresses.map((item, idx) => (
                        <div
                          key={item.code}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            padding: "11px 16px",
                            background:
                              "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 6%, transparent), color-mix(in srgb, var(--btn-color) 2%, transparent))",
                            borderTop:
                              idx > 0
                                ? "1px solid color-mix(in srgb, var(--btn-color) 10%, transparent)"
                                : "none",
                          }}
                        >
                          <img
                            src={item.logo}
                            alt={item.code}
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              objectFit: "contain",
                              flexShrink: 0,
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "var(--text-color)",
                                margin: "0 0 2px",
                              }}
                            >
                              {item.name.trim()}{" "}
                              <span style={{ opacity: 0.5, fontWeight: "400" }}>
                                ({item.code})
                              </span>
                            </p>
                            <p
                              style={{
                                fontSize: "11px",
                                color: "var(--text-color)",
                                margin: 0,
                                wordBreak: "break-all",
                                opacity: 0.6,
                                fontFamily: "monospace",
                              }}
                            >
                              {item.address}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>

              {/* Amount & Frequency */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: "20px",
                  marginBottom: "22px",
                }}
              >
                <div>
                  <div style={S.stepLabel}>Amount (USD)</div>
                  <div style={S.inputWrapper}>
                    <span style={S.inputPrefix}>$</span>
                    <input
                      type="number"
                      min="100"
                      max="999999999999"
                      step="any"
                      placeholder="100"
                      value={editAmount}
                      onKeyDown={(e) => {
                        if (e.key === "e" || e.key === "E") e.preventDefault();
                      }}
                      onChange={(e) => {
                        setEditAmount(e.target.value);
                        setEditErrors((err) => ({
                          ...err,
                          amount: validateAmountField(e.target.value),
                        }));
                      }}
                      style={S.input}
                      className="aw-input"
                    />
                  </div>
                  <p style={S.inputHint}>
                    Min: $100 · Max: 12 digits · Up to 6 decimal places
                  </p>
                  {editErrors.amount && (
                    <p style={S.errorText}>{editErrors.amount}</p>
                  )}
                </div>
                <div>
                  <div style={S.stepLabel}>Frequency (Days)</div>
                  <div style={S.inputWrapper}>
                    <span style={{ ...S.inputPrefix, left: "14px" }}>
                      <i className="mdi mdi-calendar-clock" />
                    </span>
                    <input
                      type="number"
                      min="7"
                      max="999"
                      step="1"
                      placeholder="7"
                      value={editFrequency}
                      onKeyDown={(e) => {
                        if (e.key === "." || e.key === "e" || e.key === "E")
                          e.preventDefault();
                      }}
                      onChange={(e) => {
                        setEditFrequency(e.target.value);
                        setEditErrors((err) => ({
                          ...err,
                          frequency: validateFrequencyField(e.target.value),
                        }));
                      }}
                      style={S.input}
                      className="aw-input"
                    />
                    <span style={S.inputSuffix}>days</span>
                  </div>
                  <p style={S.inputHint}>
                    Min: 7 days · Max: 999 days · Whole numbers only
                  </p>
                  {editErrors.frequency && (
                    <p style={S.errorText}>{editErrors.frequency}</p>
                  )}
                </div>
              </div>
            </div>

            <div style={S.modalFooter}>
              <button
                style={S.btnSecondary}
                onClick={closeEdit}
                disabled={editSubmitting}
              >
                Cancel
              </button>
              <button
                style={{
                  ...S.btnPrimary,
                  opacity:
                    editSubmitting || editHasAddrError || editHasBankError
                      ? 0.5
                      : 1,
                }}
                onClick={handleEditSave}
                disabled={
                  editSubmitting || editHasAddrError || editHasBankError
                }
              >
                {editSubmitting ? (
                  <>
                    <i className="mdi mdi-loading mdi-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="mdi mdi-check-circle-outline" />
                    Save Changes
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default AutomateWithdrawals;
